/**
 * The ticket system goes live for a few investors first. Investors on this list
 * see Support in the menus, on the dashboard and in the one-time tour; for
 * everyone else those ways in do not exist. An empty list releases it to all.
 *
 * The routes /requests and /requests/:ticketId stay reachable by direct link,
 * so the team can still walk through the feature.
 */
const TICKET_SYSTEM_PILOT_INVESTOR_IDS: number[] = [];

/** Tenants get the ticket system as a whole or not at all; false hides every way in for them. */
export const TICKET_SYSTEM_FOR_TENANTS = true;

export const ticketSystemEnabledFor = (investorId: number | null | undefined): boolean =>
  TICKET_SYSTEM_PILOT_INVESTOR_IDS.length === 0 ||
  (investorId != null && TICKET_SYSTEM_PILOT_INVESTOR_IDS.includes(investorId));
